<div class="card text-left h-100">
  <div class="card-header bg-light">
    <h4 class="card-title mb-0">{{ titulo }}</h4>
  </div>
  <div class="card-body wrapper m-0">
    <form class="needs-validation" novalidate id="myForm" #f="ngForm" [formGroup]="incluirNotaAuditoria">
      <div class="row" id="itens">
        <div [ngClass]="model.numero ? 'col-sm-3' : 'col-sm-4'">
          <label for="validationCustom01" class="form-label">Associado à:</label>
          <input type="text" maxlength="100" name="associado" class="form-control form-control-sm" id="associadoAId"
                 disabled placeholder="-" [(ngModel)]="model.documentoAssociado" [ngModelOptions]="{standalone: true}" />
        </div>
        <div class="col-sm-3" *ngIf="model.numero">
          <label for="validationCustom02" class="form-label">Nº Nota de Auditoria:</label>
          <input type="text" name="nSolicitacaoTecnica" class="form-control form-control-sm" id="nSolicitacao" disabled
                 placeholder="-" [ngModel]="model?.numero" maxlength="15" [ngModelOptions]="{standalone: true}" />
        </div>
        <div [ngClass]="model.numero ? 'col-sm-3' : 'col-sm-4'">
          <label for="validationCustom01" class="form-label">Prazo para Resposta: </label>
          <input type="text" class="form-control form-control-sm" id="prazoResposta" formControlName="prazoResposta"
                 placeholder="DD/MM/AAAA" bsDatepicker [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
                 [ngClass]="{ 'is-invalid': submitted && incluirNotaAuditoria.controls['prazoResposta'].invalid }" />
          <div *ngIf="submitted &&  incluirNotaAuditoria.controls['prazoResposta'].invalid" class="invalid-feedback">
            <div *ngIf="incluirNotaAuditoria.controls['prazoResposta'].errors.required">Campo obrigatório</div>
            <div *ngIf="incluirNotaAuditoria.controls['prazoResposta'].errors.dataMenorHoje">Data não pode ser anterior a
              hoje</div>

          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <label class="form-label">Nome: </label>
          <input type="text" name="nomeResponsavel" formControlName="nomeResponsavel"
                 class="form-control form-control-sm" id="nomeResponsavel" maxlength="50" />
          <div *ngIf="submitted &&  incluirNotaAuditoria.controls['nomeResponsavel'].invalid"
               class="text-danger text-xs mt-1">
            <div>Campo obrigatório</div>
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">Cargo Responsável: </label>
          <input type="text" name="cargoResponsavel" formControlName="cargoResponsavel"
                 class="form-control form-control-sm" id="cargoResponsavel" maxlength="50" />
          <div *ngIf="submitted &&  incluirNotaAuditoria.controls['cargoResponsavel'].invalid"
               class="text-danger text-xs mt-1">
            <div>Campo obrigatório</div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-12">
          <label for="validationCustom05" class="form-label">Assunto: </label>
          <input type="text" name="assunto" formControlName="assunto" class="form-control form-control-sm" id="assunto"
                 maxlength="30" />
          <div *ngIf="submitted &&  incluirNotaAuditoria.controls['assunto'].invalid" class="text-danger text-xs mt-1">
            <div>Campo obrigatório</div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12">
          <label for="validationCustom05" class="form-label">Descrição: </label>
          <div [ngClass]="{ 'border border-danger': submitted && incluirNotaAuditoria.controls['descricao'].invalid }">
            <angular-editor *ngIf="!visualizar; else descricaoVisualizar" #maxLengthEditor formControlName="descricao"
                            appKeyboardlock [config]="editorConfig">
            </angular-editor>
            <ng-template #descricaoVisualizar>
              <div class="form-control" [innerHTML]="incluirNotaAuditoria.controls['descricao'].value"
                   style="min-height: 150px; max-height: 300px; overflow-y: auto;">
              </div>
            </ng-template>
          </div>
          <div *ngIf="submitted &&  incluirNotaAuditoria.controls['descricao'].invalid" class="text-danger text-xs mt-1">
            <div>Campo obrigatório</div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12">
          <label for="validationCustom06" class="form-label">Itens</label>
          <div class="mat-elevation-z1">
            <table mat-table [dataSource]="dataSourceItems" matSortDisableClear #tabela3="matSort" matSort
                   matSortDirection="asc">
              <tr mat-header-row *matHeaderRowDef="['numero', 'tituloItem', 'status', 'statusAvaliacao', 'actions']"
                  class="bg-light">
              </tr>

              <ng-container matColumnDef="numero">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Nº
                </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="!element?.numero">-</span>
                  <span *ngIf="element?.numero">{{ element.numero }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="tituloItem">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Titulo do item
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.titulo }}
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Status
                </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="!element?.status">-</span>
                  <span *ngIf="element?.status?.codigo === 1"
                        class="badge bg-success text-xs">{{element?.status?.descricao}}</span>
                  <span *ngIf="element?.status?.codigo === 2"
                        class="badge bg-secondary text-xs">{{element?.status?.descricao}}</span>
                  <span *ngIf="element?.status?.codigo === 3"
                        class="badge bg-danger text-xs">{{element?.status?.descricao}}</span>
                  <span *ngIf="element?.status?.codigo === 4"
                        class="badge bg-info text-xs">{{element?.status?.descricao}}</span>
                  <span *ngIf="element?.status?.codigo === 5"
                        class="badge bg-warning text-xs">{{element?.status?.descricao}}</span>
                  <span *ngIf="element?.status?.codigo === 6"
                        class="badge bg-primary text-xs">{{element?.status?.descricao}}</span>
                  <span *ngIf="element?.status?.codigo === 7"
                        class="badge bg-info text-xs">{{element?.status?.descricao}}</span>

                  <i *ngIf="element?.status?.codigo === 3" class="fas fa-info-circle"
                     [matTooltip]="formatarTooltipCanc(element)" matTooltipClass="tooltip-avaliacao"
                     matTooltipPosition="above" style="cursor: pointer; margin-left: 0.5rem;">
                  </i>

                </td>
              </ng-container>

              <ng-container matColumnDef="statusAvaliacao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Avaliação
                </th>
                <td mat-cell *matCellDef="let element">
                  <i *ngIf="isStatusAvaliacaoVazio(element?.statusAvaliacao)" class="fas fa-minus text-muted"></i>
                  <span *ngIf="!isStatusAvaliacaoVazio(element?.statusAvaliacao) && element?.statusAvaliacao?.codigo === 1"
                        class="badge bg-info text-xs">{{element?.statusAvaliacao?.descricao}}</span>
                  <span *ngIf="!isStatusAvaliacaoVazio(element?.statusAvaliacao) && element?.statusAvaliacao?.codigo === 2"
                        class="badge bg-warning text-xs">{{element?.statusAvaliacao?.descricao}}</span>
                  <span *ngIf="!isStatusAvaliacaoVazio(element?.statusAvaliacao) && element?.statusAvaliacao?.codigo === 3"
                        class="badge bg-danger text-xs">{{element?.statusAvaliacao?.descricao}}</span>

                  <i *ngIf="element?.comentarioAvaliacao" class="fas fa-info-circle"
                     [matTooltip]="formatarTooltipAvaliacao(element)" matTooltipClass="tooltip-avaliacao"
                     matTooltipPosition="above" style="cursor: pointer; margin-left: 0.5rem;">
                  </i>
                </td>
              </ng-container>

              <ng-container cdkColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef style="max-width: 90px;">
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="block">
                  <div class="d-flex w-100 justify-content-center align-items-center">
                    <button type="button" class="btn btn-primary btn-xs text-left ml-1"
                            *ngIf="element?.status?.codigo !== 3 && acaoResponder" (click)="modalResponderItem(element)">
                      <i class="fas fa-pen" matTooltip="Responder" matTooltipPosition="above"></i>
                    </button>
                    <button type="button" class="btn btn-primary btn-xs text-left ml-1"
                            *ngIf="element?.status?.codigo !== 3 && acaoAvaliar" (click)="modalAvaliarItem(element)">
                      <i class="fas fa-check" matTooltip="Avaliar" matTooltipPosition="above"></i>
                    </button>
                    <button type="button" class="btn btn-info btn-xs text-left ml-1"
                            (click)="modalVisualizarItem(element)">
                      <i class="far fas fa-eye" matTooltip="Visualizar" matTooltipPosition="above"></i>
                    </button>
                  </div>
                </td>
              </ng-container>
              <tr mat-row
                  *matRowDef="let row; columns: ['numero', 'tituloItem', 'status', 'statusAvaliacao', 'actions']"></tr>
            </table>
            <h5 class="table-no-data" [hidden]="dataSourceItems?.data?.length > 0">
              Nenhum registro encontrado
            </h5>
            <mat-paginator #TableThreePaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
            </mat-paginator>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card-footer">
    <div class="d-flex w-100 justify-content-between align-items-center">

      <div class="list2">
        <button *ngIf="acaoResponder" type="button" class="btn btn-warning btn-sm mr-1" (click)="prorrogarPrazo()">
          <i class="fas fa-hourglass"></i> Prorrogar Prazo
        </button>
        <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
          <i class="fas fa-times"></i> Fechar
        </button>
      </div>
    </div>
  </div>
</div>
